export const getFormattedOrderDate = (dateObject) => {
  const month = dateObject.getMonth() + 1; // is indexed to 0 so we need to + 1
  const monthFormatted = (month) < 10 ? `0${month}` : `${month}`;
  const dateFormatted = dateObject.getDate() < 10 ? `0${dateObject.getDate()}` : dateObject.getDate();

  return `${monthFormatted}/${dateFormatted}/${dateObject.getFullYear().toString().slice(2)}`;
};

function getUserName() {
  const thdCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : null;
  return thdCustomer?.username || null;
}

function getUserEmail() {
  const thdCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : null;
  return thdCustomer?.email || null;
}

function getAuthStatus() {
  const thdCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : null;
  return thdCustomer ? (thdCustomer.isKMSI && thdCustomer.isPersistedKMSI)
    || !thdCustomer.isLoggedIn : null;
}

function isPersisted() {
  const thdCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : null;
  return (!thdCustomer?.isKMSI && thdCustomer?.isPersisted) || null;
}

export {
  getUserEmail,
  getUserName,
  getAuthStatus,
  isPersisted,
};
